// ==========================================================================
// Shared DataTable styles — one consistent, market-standard table look
// used across the whole app (react-data-table-component `customStyles`).
//
// Import and pass to every <DataTable customStyles={sharedTableStyles} />.
// Keeps tables visually consistent: light uppercase header, zebra rows,
// soft borders, comfortable spacing, subtle hover.
// ==========================================================================

const INK = '#1f2937';
const INK_SOFT = '#475467';
const MUTED = '#6b7280';
const LINE = '#e9edf3';
const LINE_SOFT = '#f1f4f8';
const HEAD_BG = '#f8fafc';
const ROW_ALT = '#fcfdfe';
const HOVER_BG = '#f5f6fb';

export const sharedTableStyles = {
  table: {
    style: {
      backgroundColor: 'transparent'
    }
  },
  tableWrapper: {
    style: {
      display: 'block'
    }
  },
  headRow: {
    style: {
      backgroundColor: HEAD_BG,
      borderTopLeftRadius: '0',
      borderTopRightRadius: '0',
      borderBottom: `1px solid ${LINE}`,
      minHeight: '48px'
    }
  },
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '11px',
      color: MUTED,
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
      paddingTop: '8px',
      paddingBottom: '8px'
    }
  },
  rows: {
    style: {
      minHeight: '52px',
      borderBottom: `1px solid ${LINE_SOFT}`,
      backgroundColor: '#ffffff',
      fontSize: '13px',
      color: INK
    },
    stripedStyle: {
      backgroundColor: ROW_ALT
    },
    highlightOnHoverStyle: {
      backgroundColor: HOVER_BG,
      borderBottomColor: LINE,
      outline: 'none',
      transitionDuration: '0.15s',
      transitionProperty: 'background-color'
    }
  },
  cells: {
    style: {
      color: INK,
      fontWeight: 600,
      fontSize: '13px',
      paddingTop: '8px',
      paddingBottom: '8px'
    }
  },
  pagination: {
    style: {
      borderTop: `1px solid ${LINE_SOFT}`,
      paddingTop: '10px',
      paddingBottom: '10px',
      fontSize: '13px',
      color: INK_SOFT
    },
    pageButtonsStyle: {
      borderRadius: '8px',
      height: '32px',
      width: '32px',
      padding: '4px',
      margin: '0 2px',
      transition: 'background-color 0.15s ease'
    }
  }
};

/** Assets table — centered cells, fixed column widths, horizontal scroll friendly */
export const assetsTableStyles = {
  ...sharedTableStyles,
  headRow: {
    style: {
      ...sharedTableStyles.headRow.style,
      backgroundColor: '#f1f5f9',
      borderBottom: '2px solid #e2e8f0',
      minHeight: '52px'
    }
  },
  headCells: {
    style: {
      ...sharedTableStyles.headCells.style,
      color: '#334155',
      fontWeight: 700,
      justifyContent: 'center',
      textAlign: 'center',
      paddingLeft: '10px',
      paddingRight: '10px',
      whiteSpace: 'normal',
      lineHeight: '1.35',
      overflow: 'visible'
    }
  },
  rows: {
    ...sharedTableStyles.rows,
    style: {
      ...sharedTableStyles.rows.style,
      color: '#6b7280',
      minHeight: '48px',
      borderBottom: '1px solid #e2e8f0'
    }
  },
  cells: {
    style: {
      ...sharedTableStyles.cells.style,
      justifyContent: 'center',
      textAlign: 'center',
      paddingLeft: '10px',
      paddingRight: '10px',
      color: '#6b7280',
      fontWeight: 600,
      alignItems: 'center'
    }
  }
};

export default sharedTableStyles;
